var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { TextInput } from '../TextInput';
import { CodeInputTestIdFactory } from './interactions';
import { useCodeInput } from './useCodeInput';
import styles from './CodeInput.module.css';
export const CodeInput = ({ 'aria-labelledby': ariaLabelledBy, autoFocus, 'data-testid': testid, digitAriaLabel, disabled, isNumeric = true, isOperationRunning, length, onCompletion, }) => {
    _react_refresh_temp_2();
    const { inputRefs, onChange, onKeyDown, onPaste, values } = useCodeInput({
        isNumeric,
        length,
        onCompletion,
    });
    // Required because setting auto focus on the first input element breaks
    // the focus logic from useCodeInput when component is being recalculated
    useEffect(() => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions -- intentional ternary/short-circuit statement (allowed on master; v8 newly added this rule)
        autoFocus && inputRefs[0]?.current?.focus();
    }, [autoFocus, inputRefs]);
    return (
    // Groups the boxes under the visible instruction so each name stays short (WCAG 2.5.3)
    _jsx("div", { "aria-labelledby": ariaLabelledBy, className: styles.Group, "data-testid": CodeInputTestIdFactory.getCodeInputGroupTestId(testid), role: "group", children: values.map((v, i) => (_jsx(TextInput, { "aria-label": digitAriaLabel(i + 1, length), autoComplete: i === 0 ? 'one-time-code' : undefined, className: styles.Container, "data-testid": CodeInputTestIdFactory.getCodeInputDigitTestId(testid, i + 1), disabled: disabled, inputClassName: styles.Input, onChange: (e) => onChange(e, i), onKeyDown: (e) => onKeyDown(e, i), onPaste: onPaste, readOnly: isOperationRunning, ref: inputRefs[i], value: v }, i))) }));
};
_react_refresh_temp_1 = CodeInput;
$RefreshReg$(_react_refresh_temp_1, "CodeInput");
_react_refresh_temp_2(CodeInput, "322zZfaBENRAsbv+2P4ryTxFvZM=", false, () => [useCodeInput]);
